import React, { useEffect, useState } from 'react';
import { GiftIcon, XIcon } from 'lucide-react';
export function StickyCCCBanner() {
  const [shouldShow, setShouldShow] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
      if (scrollPercent > 55 && !isDismissed) {
        setShouldShow(true);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);
  const dismiss = () => {
    setIsDismissed(true);
    setShouldShow(false);
  };
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-transform duration-500 ease-out ${shouldShow ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!shouldShow} data-id="element-323">
      <div className="bg-brand-blue-900 border-t border-brand-blue-700 shadow-2xl" data-id="element-324">
        <div className="container-wide py-3 sm:py-4 flex items-center justify-between gap-4" data-id="element-325">
          <div className="flex items-center gap-3 sm:gap-4 min-w-0" data-id="element-326">
            <div className="w-10 h-10 rounded-full bg-brand-green/20 flex items-center justify-center flex-shrink-0" data-id="element-327">
              <GiftIcon className="w-5 h-5 text-brand-green-300" data-id="element-328" />
            </div>
            <div className="min-w-0" data-id="element-329">
              <div className="text-white font-heading font-bold text-sm sm:text-base truncate" data-id="element-330">
                Join 15,000+ Customer Care Club Members
              </div>
              <div className="text-brand-blue-200 text-xs sm:text-sm hidden sm:block" data-id="element-331">
                Get $10 off premium pet food + earn reward points on every
                purchase
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0" data-id="element-332">
            <button className="btn-green py-2 sm:py-2.5 px-4 sm:px-6 text-xs sm:text-sm whitespace-nowrap" data-id="element-333">
              Join Free
            </button>
            <button onClick={dismiss} className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-all" aria-label="Dismiss" data-id="element-334">
              <XIcon className="w-4 h-4" data-id="element-335" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}